<template>
  <div class="about">
    <!-- <h3>JOYINME PTE. LTD</h3> -->
    <!-- <h3>JOYINME PTE. LTD.</h3> -->
    <!-- <h3>Terms of Service</h3>
    <h2>Last updated: </h2>
    <h2>Welcome to AI Sweetheart! </h2> -->
  </div>
</template>

<script>
export default {

};
</script>

<style lang="less" scoped>
  .about{
    height: 100%;
    display: flex;
    justify-content:center;
    align-items: center;
    flex-flow: column;
  }
</style>
